export default {"src":"/_next/static/media/lock.9f572218.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};